import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { FormikContextType } from 'formik';
import moment from 'moment';

import * as fromApp from '../../../store/app';

import MFormAddressInput from 'app/ui/MForm/MFormFields/MFormAddressInput/MFormAddressInput';
import MFormDatetime from 'app/ui/MForm/MFormFields/MFormDatetime/MFormDatetime';
import MButton from 'app/ui/MButton/MButton';
import MIcon from 'app/ui/MIcon/MIcon';

import setFieldProps from 'app/utils/setFieldProps';

import { TimeFormats } from 'app/constants/TimeFormat';

import classes from './ByDestination.module.scss';
import { condClass } from 'app/utils/general';
import { DestinationForm } from './ByDestination.model';

interface PropsFromState {
  maxSeats: number;
}

interface Props extends PropsFromState {
  className?: string;
  returnDateVisibility: boolean;
  form: FormikContextType<DestinationForm>;
}

const ByDestinationView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <form
        className={condClass({ [classes['details']]: true, [String(props.className)]: !!props.className })}
        onSubmit={props.form.handleSubmit}
      >
        <div className={classes['field']}>
          <MIcon className={classes['icon']} name="cilLocationPin"></MIcon>
          <MFormAddressInput
            className={classes['input']}
            placeholder={t('reservationBar.formDestination.from')}
            {...setFieldProps(props.form, 'from')}
          />
        </div>
        <div className={classes['field']}>
          <MIcon className={classes['icon']} name="cilLocationPinCheck"></MIcon>
          <MFormAddressInput className={classes['input']} placeholder={t('reservationBar.formDestination.to')} {...setFieldProps(props.form, 'to')} />
        </div>
        <div className={classes['field']}>
          <MIcon className={classes['icon']} name="cilCalendar"></MIcon>
          <MFormDatetime
            className={classes['input']}
            {...setFieldProps(props.form, 'date')}
            dateFormat={TimeFormats.UIFormatDatePicker}
            showTimeSelect
            placeholder={t('reservationBar.formDestination.date')}
            minDate={moment()}
          ></MFormDatetime>
        </div>
        {props.returnDateVisibility ? (
          <div className={classes['field']}>
            <MIcon className={classes['icon']} name="cilCalendar"></MIcon>
            <MFormDatetime
              className={classes['input']}
              {...setFieldProps(props.form, 'returnDate')}
              dateFormat={TimeFormats.UIFormatDatePicker}
              showTimeSelect
              placeholder={t('reservationBar.formDestination.returnDate')}
              minDate={moment()}
            ></MFormDatetime>
          </div>
        ) : null}
        <MButton
          className={classes['btn']}
          type="submit"
          disabled={!props.form.values.from || !props.form.values.to || !props.form.values.date}
        >
          {t('reservationBar.btnFindServices')}
        </MButton>
      </form>
    </React.Fragment>
  );
};

ByDestinationView.displayName = 'ByDestinationView';
ByDestinationView.defaultProps = {};

const mapStateToProps = (state: fromApp.AppState) => {
  return {
    maxSeats: state.settings.specs?.maxSeats || 1,
  };
};

export default connect(mapStateToProps)(ByDestinationView);
